import { useEffect } from "react";
import { useSelector } from "react-redux";

/**
 * Marca body[data-client="digital"] solo cuando idbusiness_group === 1.
 * Úsalo en cada página interna que tenga BarraMenu.
 */
const useDigitalTheme = () => {
  const { idbusiness_group } = useSelector((state: any) => state.emp);
  const businessGroupId = idbusiness_group || 1;

  useEffect(() => {
    if (businessGroupId === 1) {
      document.body.dataset.client = "digital";
    }
    return () => {
      delete document.body.dataset.client;
    };
  }, [businessGroupId]);
};

export default useDigitalTheme;